import { perFacadeApi, facadeApi } from 'helpers/api.helper';
export var fetchCrosswalkUser = function (userId, type) {
    return perFacadeApi.get("/eolsUser/".concat(userId, "/type/").concat(type, "/crosswalk"));
};
export var fetchUserByUserId = function (id) {
    return facadeApi.get("v1/eolsUser/".concat(id));
};
export var fetchAllEolsUserByEolsUserId = function (eolsUserId, type) {
    if (eolsUserId) {
        return perFacadeApi.get("/eolsUser/".concat(eolsUserId, "/type/").concat(type, "/crosswalk/all"));
    }
    return Promise.resolve({ data: [] });
};
export var fetchExternalUserInfo = function (evolveUserName, newToken) {
    var fetchUrl = "/eolsUser/externalUsername/".concat(evolveUserName);
    if (newToken) {
        var header = new Headers({
            Authorization: "Bearer ".concat(newToken)
        });
        return facadeApi.get(fetchUrl, { header: header });
    }
    return facadeApi.get(fetchUrl);
};
